export class ODataExpand{
    constructor(private property:string){
        
    }

    public toString():string{
        return this.property;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-expand.ts